module.exports = __webpack_public_path__ + "img/title.f29c7862.png";